import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import * as MC_CONST from '../../tinode/constants'
import { IconClose } from "../../icons/svg";
import { Tinode } from "../../tinode/tinode";
import { Topic } from '../../tinode/topic'
import HiddenOtpInput from '../hidden-otp-input.jsx'
import { profile } from "../../stores/storages/ProfileStorage";
import formatter from '../../services/formatter'
import Helpers from "../../lib/helpers";
import HashNavigation from '../../lib/navigation.js'


const messages = defineMessages({
	dialog_hide_topic_title: {
		id: "dialog_hide_topic_title",
		defaultMessage: "Hide conversation",
		description: "Hide conversation",
	},
	dialog_unhide_topic_title: {
		id: "dialog_unhide_topic_title",
		defaultMessage: "Unhide conversation",
		description: "Unhide conversation",
	},
	dialog_set_pin_hide_topic_title: {
		id: "dialog_set_pin_hide_topic_title",
		defaultMessage: "Enter your new PIN",
		description: "Set new pin hide conversation",
	},
	reset_hide_password_desc: {
		id: "reset_hide_password_desc",
		defaultMessage: "Enter your PIN to continue. If forgotten, please ",
		description: "Reset hide conversations password describe",
	},
	reset_hide_password: {
		id: "reset_hide_password",
		defaultMessage: "Reset PIN",
		description: "Reset hide conversations password button",
	},
	hide_topic_success: {
		id: "hide_topic_success",
		defaultMessage: "Conversation {name} is now hidden",
		description: "Notify hide topic success",
	},
	unhide_topic_success: {
		id: "unhide_topic_success",
		defaultMessage: "Conversation {name} is now unhidden",
		description: "Notify unhide topic success",
	},
	hide_topic_fail: {
		id: "notify_error",
		defaultMessage: "An error occurred. Please try again later",
		description: "Notify error",
	},
	hide_topic_wrong_pin: {
		id: "hide_topic_wrong_pin",
		defaultMessage: "The PIN is incorrect",
		description: "The PIN is incorrect",
	},
	reset_hide_password_warning: {
		id: "reset_hide_password_warning",
		defaultMessage: "Resetting your PIN will remove old PIN and all settings. Also, ALL your current hidden conversations will be DELETED.",
		description: "Reset hide password warning",
	},
	reset_password_success: {
		id: "reset_password_success",
		defaultMessage: "Reset PIN successfully",
		description: "Reset PIN successfully",
	},
	enter_new_pin_desc: {
		id: "enter_new_pin_desc",
		defaultMessage: "Remember your PIN. All hidden conversations will be lost if you forget the code.",
		description: "Remember your PIN. All hidden conversations will be lost if you forget the code.",
	},
	enter_new_pin_confirm: {
		id: "enter_new_pin_confirm",
		defaultMessage: "Re-enter your PIN",
		description: "Re-enter your PIN",
	},
	enter_new_pin_confirm_error: {
		id: "enter_new_pin_confirm_error",
		defaultMessage: "PIN code does not match, please check again.",
		description: "PIN code does not match, please check again.",
	},
	set_password_success: {
		id: "set_password_success",
		defaultMessage: "Set PIN successfully.",
		description: "Set PIN successfully.",
	},
	same_old_hide_password_warning: {
		id: "same_old_hide_password_warning",
		defaultMessage: "Setting new password failed. The new password must not be the same as the old password..",
		description: "Setting new password failed. The new password must not be the same as the old password.",
	}

})

class HideTopic extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = this.getBlankState(props)


		this.getBlankState = this.getBlankState.bind(this)
		this.getTitle = this.getTitle.bind(this)
		this.renderPasswordView = this.renderPasswordView.bind(this)
		this.renderPasswordInput = this.renderPasswordInput.bind(this)
		this.renderResetPasswordDesc = this.renderResetPasswordDesc.bind(this)
		this.renderSetPasswordInput = this.renderSetPasswordInput.bind(this)
		this.renderNewPasswordDesc = this.renderNewPasswordDesc.bind(this)
		this.handleVerifyPassword = this.handleVerifyPassword.bind(this)
		this.handleSetPassword = this.handleSetPassword.bind(this)
		this.handleResetHidePassword = this.handleResetHidePassword.bind(this)
		this.onResetPassword = this.onResetPassword.bind(this)
	}

	getBlankState(props = {}) {
		return {
			title: this.getTitle(props.action),
			otp: '',
			showConfirmPassword: false,
			desc: '',
			action: props.action,
		}
	}

	getTitle(action) {
		const { formatMessage } = this.props.intl;
		let title
		const actionType = action || this.props.action
		switch (actionType) {
			case MC_CONST.HIDE_TOPIC_ACTION.SET_NEW_PASSWORD: {
				title = formatMessage(messages.dialog_set_pin_hide_topic_title)
				break
			}
			case MC_CONST.HIDE_TOPIC_ACTION.VERIFY_PASSWORD: {
				switch (this.props.subAction) {
					case MC_CONST.HIDE_TOPIC_SUB_ACTION.HIDE: {
						title = formatMessage(messages.dialog_hide_topic_title)
						break;
					}
					case MC_CONST.HIDE_TOPIC_SUB_ACTION.UNHIDE: {
						title = formatMessage(messages.dialog_unhide_topic_title)
						break;
					}
				}
				break
			}
			default: {
				title = formatMessage(messages.dialog_hide_topic_title)
			}

		}
		return title
	}

	handleVerifyPassword(otp) {
		const { formatMessage } = this.props.intl;

		const password = formatter.xxteaDecrypt(profile.settings.hide_thread.pin, profile.username)
		if (otp === password) {
			console.log('handleVerifyPassword success', otp, password)
			if (this.state.action === MC_CONST.HIDE_TOPIC_ACTION.CHANGE_PASSWORD) {
				this.setState({
					action: MC_CONST.HIDE_TOPIC_ACTION.SET_NEW_PASSWORD,
				})
				this.child.resetOtp()

			} else {
				const isSelect = this.props.subAction === MC_CONST.HIDE_TOPIC_SUB_ACTION.SELECT_TOPIC
				if (isSelect) {
					this.props.callback()
					this.props.onClose()
				} else {
					const isHide = this.props.subAction === MC_CONST.HIDE_TOPIC_SUB_ACTION.HIDE
					this.props.tinode.hideTopic(this.props.topicName, isHide).then((data) => {
						if (data && data.errorCode === MC_CONST.ERROR_CODE.SUCCESS) {
							const topicInfo = this.props.tinode.getTopicByName(this.props.topicName)
							let topicName = ''
							if (topicInfo) {
								topicName = Topic.getTopicName(topicInfo)
							}
							if (isHide) {
								Helpers.showSuccessToasts(formatMessage(messages.hide_topic_success, { name: topicName }))
							} else {
								Helpers.showSuccessToasts(formatMessage(messages.unhide_topic_success, { name: topicName }))
							}
							this.props.onClose()
						} else {
							console.log('=============== hide error', data)
							Helpers.showErrorToasts(formatMessage(messages.hide_topic_fail))
						}
					})
				}
			}
		} else {
			console.log('handleVerifyPassword fail', otp, password)
			Helpers.showErrorToasts(formatMessage(messages.hide_topic_wrong_pin))
			this.child.resetOtp()
		}
	}

	handleSetPassword(otp) {
		const { formatMessage } = this.props.intl;
		if (this.state.showConfirmPassword === false) {
			const oldOtp = profile?.settings?.hide_thread?.pin ? formatter.xxteaDecrypt(profile.settings.hide_thread.pin, profile.username) : null
			if (otp === oldOtp) {
				Helpers.showErrorToasts(formatMessage(messages.same_old_hide_password_warning))
			} else {
				this.setState({
					otp,
					showConfirmPassword: true,
				})
			}
			this.child.resetOtp()
		} else if (otp === this.state.otp) {
			this.props.tinode.setNewHidePassword(otp).then((data) => {
				if (data && data.errorCode === MC_CONST.ERROR_CODE.SUCCESS) {
					if (this.props.topicName) {
						this.props.tinode.hideTopic(this.props.topicName, true).then((res) => {
							if (res && res.errorCode === MC_CONST.ERROR_CODE.SUCCESS) {
								Helpers.showSuccessToasts(formatMessage(messages.hide_topic_success, { name: '' }))
								this.props.onClose()
							} else {
								Helpers.showErrorToasts(formatMessage(messages.hide_topic_fail))
								this.setState({
									otp: '',
									showConfirmPassword: false,
								})
								this.child.resetOtp()
							}
						})
					} else {
						Helpers.showSuccessToasts(formatMessage(messages.set_password_success))
						this.props.onClose()
					}
				} else {
					Helpers.showErrorToasts(formatMessage(messages.hide_topic_fail))
					this.setState({
						otp: '',
						showConfirmPassword: false,
					})
					this.child.resetOtp()
				}
			})
		} else {
			Helpers.showErrorToasts(formatMessage(messages.enter_new_pin_confirm_error))
			this.setState({
				otp: '',
				showConfirmPassword: false,
			})
			this.child.resetOtp()
		}

	}

	handleResetHidePassword() {
		const { formatMessage } = this.props.intl;
		this.props.onShowAlert(
			formatMessage(messages.reset_hide_password), // title
			formatMessage(messages.reset_hide_password_warning), // content
			(_) => this.onResetPassword(), // onConfirm
			null, // "OK"
			true, // Show Reject button
			null // "Cancel"
		);
	}

	onResetPassword() {
		this.props.tinode.resetHidePassword().then((res) => {
			const { formatMessage } = this.props.intl;
			if (res.errorCode === MC_CONST.ERROR_CODE.SUCCESS) {
				Helpers.showSuccessToasts(formatMessage(messages.reset_password_success))
				this.props.onClose()
				this.props.onSearchContacts(Tinode.DEL_CHAR)
				HashNavigation.navigateTo('');
			} else {
				Helpers.showErrorToasts(formatMessage(messages.hide_topic_fail))
			}

		})
	}

	renderPasswordInput() {
		return (
			<HiddenOtpInput
				ref={instance => { this.child = instance; }}
				length={4}
				onComplete={this.handleVerifyPassword}
			/>
		)
	}

	renderChangePasswordInput() {
		return (
			<HiddenOtpInput
				ref={instance => { this.child = instance; }}
				length={4}
				onComplete={this.handleVerifyPassword}
			/>
		)
	}

	renderSetPasswordInput() {
		return (
			<HiddenOtpInput
				ref={instance => { this.child = instance; }}
				length={4}
				onComplete={this.handleSetPassword}
			/>
		)
	}

	renderResetPasswordDesc() {
		const { formatMessage } = this.props.intl;
		return (<div className="desc">
			{`${formatMessage(messages.reset_hide_password_desc)} `}
			<span
				className="reset-button"
				onClick={this.handleResetHidePassword}
			>{formatMessage(messages.reset_hide_password)}</span>
		</div>)
	}

	renderNewPasswordDesc() {
		const { formatMessage } = this.props.intl;
		if (this.state.showConfirmPassword) {
			return (<div className="desc">
				{`${formatMessage(messages.enter_new_pin_confirm)}`}
			</div>)
		} else {
			return (<div className="desc">
				{`${formatMessage(messages.enter_new_pin_desc)}`}
			</div>)
		}

	}

	renderPasswordView() {
		switch (this.state.action) {
			case MC_CONST.HIDE_TOPIC_ACTION.SET_NEW_PASSWORD:
				return (
					<div>
						<div className="otp-input-view">
							{this.renderSetPasswordInput()}
						</div>
						{this.renderNewPasswordDesc()}
					</div>
				)
			case MC_CONST.HIDE_TOPIC_ACTION.CHANGE_PASSWORD:
			case MC_CONST.HIDE_TOPIC_ACTION.VERIFY_PASSWORD:
			default:
				return (
					<div>
						<div className="otp-input-view">
							{this.renderPasswordInput()}
						</div>
						{this.renderResetPasswordDesc()}
					</div>
				)
		}
	}

	render() {
		const { formatMessage } = this.props.intl;
		const { motions, onClose } = this.props
		return (
			<Suspense
				fallback={
					<div className="panel-form-row">
						<FormattedMessage
							id="loading_note"
							defaultMessage="Loading..."
							description="Message shown when component is loading"
						/>
					</div>
				}>
				<div className="dialog-hide-topic">
					<div className="header">
						<div className="title">
							{this.state.title}
						</div>
						<div className="icon" onClick={onClose}>
							<IconClose />
						</div>
					</div>
					{this.renderPasswordView()}
				</div>
			</Suspense>
		)
	}
}
export default injectIntl(HideTopic);